import React from 'react';
import VerticalNav from 'components/v2/navs/VerticalNav';
import { useTranslation } from 'react-i18next';
import { isProd } from 'helpers/helper_functions';

export default function SidebarNav({ activeTab = 'drayageFsc', user }) {
  const { t } = useTranslation();

  return (
    <ul className="flex flex-col gap-y-7">
      <li>
        <div className="text-xs font-semibold leading-6 text-gray-400">
          {t('DRAYAGE')}
        </div>
        <VerticalNav>
          <VerticalNav.NavItem
            url={`/users/${user.id}/settings/rates`}
            active={activeTab === 'drayageFsc'}
          >
            {t('FSC').toUpperCase()}
          </VerticalNav.NavItem>
        </VerticalNav>
        <VerticalNav>
          <VerticalNav.NavItem
            url={`/users/${user._id}/rate-card`}
            active={activeTab === 'drayageRateCard'}
          >
            {t('DRAYAGE_RATE_CARD')}
          </VerticalNav.NavItem>
        </VerticalNav>
      </li>

      {!isProd() && (
        <li>
          <div className="text-xs font-semibold leading-6 text-gray-400">
            {t('SHORTHAUL')}
          </div>
          <VerticalNav>
            <VerticalNav.NavItem
              url={`/users/${user.id}/settings/rates/shorthaul/fsc`}
              active={activeTab === 'shorthaulFsc'}
            >
              {t('FSC').toUpperCase()}
            </VerticalNav.NavItem>
          </VerticalNav>
        </li>
      )}
    </ul>
  );
}
